import styled, { keyframes } from 'styled-components';
import NextLink from 'next/link';
import { grey20, grey40, blue, black } from 'Styles/colors';
import { fontTitle, fontBody } from 'Styles/fonts';

import InformationCard from '../../../InformationCard/InformationCard';
import {
  Header,
  Content
} from '../../../InformationCard/InformationCard.styled';
import ButtonIcon from '../../../Icons/ButtonIcon';
import TooltipOriginal from '../../../Tooltip/Tooltip';
import { ButtonIconWithFocus } from '../../../Tooltip/Tooltip.styled';

export const FADE_ANIMATION_DURATION = 300;

const pulseAnimation = keyframes`
  0%, 100% {
    background-color: ${grey20};
  }
  45% {
    background-color: ${grey40};
  }
`;

export const DonationCounter = styled(InformationCard)`
  ${Header} {
    padding-bottom: 4px;
  }

  ${Content} {
    padding-bottom: 12px;
  }
`;

export const Title = styled.h2`
  ${fontTitle(20)};
  color: ${black};
`;

export const Body = styled.div`
  margin: 0;
  padding: 0;
  ${fontBody(14)};
  color: ${black};
`;

export const Desc = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  gap: 3px;
`;

export const Emphasis = styled.span`
  color: ${blue};
  display: inline-block;
`;

export const Link = styled(NextLink)`
  text-decoration: underline;
  ${fontBody(14)};
  color: ${black};
`;

export const LoadingBlock = styled.div`
  height: ${({ $height }) => ($height ? `${$height}px` : '24px')};
  border-radius: 4px;
  animation: ${pulseAnimation} 3s ease-out infinite normal;
  width: 100%;
`;

export const QuestionTip = styled(ButtonIcon).attrs({
  name: 'question-mark',
  variant: 'defaultLight'
})`
  ${fontBody(20)};
  margin-left: auto;
  margin-right: -12px;
  padding: 0;
  min-height: 20px;
  height: 20px;
`;

export const Tooltip = styled(TooltipOriginal)`
  ${ButtonIconWithFocus} {
    ${fontBody(16)};
    min-height: 40px;
    height: 40px;
    min-width: 40px;
    width: 40px;
  }
`;

export const TooltipBody = styled.div`
  width: 256px;
`;

export default {};
